export enum Package {
  Pallet = 'PALLET',
  Box = 'BOX',
  Barrel = 'BARREL',
  Sack = 'SACK',
  Other = 'OTHER',
  Pallet2 = 'PALLET',
  Box2 = 'BOX',
  BoxPallet2 = 'BOXPALLET',
  Other2 = 'OTHER',
}
